import { Component, EventEmitter, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { applicationFrom } from '../../../auth/models/commonEnum';

@Component({
  selector: 'app-meeting-agenda-list',
  templateUrl: './meeting-agenda-list.component.html',
  styleUrls: ['./meeting-agenda-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MeetingAgendaListComponent implements OnInit {
	meetingAgenda: number;
	   contentHeader: any;  
  	constructor() { }
	  @Output() myOutput:EventEmitter<string>= new EventEmitter(); 
	ngOnInit(): void {
		this.meetingAgenda = applicationFrom.MEETING_AGENDA;

		this.contentHeader = {
			headerTitle: 'Meeting Agenda',
			actionButton: true,
			breadcrumb: {
			  type: '',
			  links: [
				{
				  name: 'Meeting Agenda',
				  isLink: true,
				  link: '/imeeting-agenda-list'
				}
			  ]
			}
		  };
	}
}
